import React, { Component } from "react";
import AUX from "../../hoc/Aux_";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import FormControl from "@material-ui/core/FormControl";
import { postDictionary, putDictionary } from "../../api/dictionary";
import Grid from "@material-ui/core/Grid";
import { InputLabel, Input, FormHelperText } from "@material-ui/core";
import { postCms, putCms, putLayer, postLayer } from "../../api/cms";
import _ from "lodash";

class EditCms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gid: this.props.dataSelected,
      description: "",
      open: false,
      title: "",
      nama: "",
      host: "",
      layer: "",
      sublayer: "",
      kategori: "",
      error: false,
    };
  }

  componentWillMount() {
    console.log(this.props.layerData);
    console.log(this.props.dataSelected);
    var a = _.find(this.props.layerData, { gid: this.state.gid });
    console.log(a);
    this.setState({
      nama: a.nama,
      host: a.host,
      layer: a.layer,
      sublayer: a.sublayer,
      kategori: a.kategori,
    });
  }

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  submitForm = () => {
    if (
      this.state.nama &&
      this.state.host &&
      this.state.layer &&
      this.state.sublayer &&
      this.state.kategori
    ) {
      let data = {
        gid: this.state.gid,
        nama: this.state.nama,
        host: this.state.host,
        layer: this.state.layer,
        sublayer: this.state.sublayer,
        kategori: this.state.kategori,
      };
      putLayer(this.state.gid, data)
        .then((response) => {
          console.log(response);
          this.props.handleOpen(false);
          this.props.handleReload(true);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.setState({ error: true });
    }
  };

  handleError = (e) => {
    if (this.state.error) if (!e) return true;
    return false;
  };

  render() {
    return (
      <Grid item xs={12}>
        <h3>Edit Layer</h3>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel htmlFor="word">Nama</InputLabel>
            <Input
              id="word"
              aria-describedby="word"
              value={this.state.nama}
              onChange={(e) => this.handleChangeText("nama", e)}
              error={this.handleError(this.state.nama)}
            />
            {this.handleError(this.state.nama) ? (
              <FormHelperText>This field is required</FormHelperText>
            ) : null}
          </FormControl>{" "}
          <FormControl fullWidth>
            <InputLabel htmlFor="wordTarget">Host</InputLabel>
            <Input
              id="wordTarget"
              aria-describedby="wordTarget"
              fullWidth={true}
              value={this.state.host}
              onChange={(e) => this.handleChangeText("host", e)}
              error={this.handleError(this.state.host)}
            />
            {this.handleError(this.state.host) ? (
              <FormHelperText>This field is required</FormHelperText>
            ) : null}
          </FormControl>{" "}
          <FormControl fullWidth>
            <InputLabel htmlFor="word">Layer</InputLabel>
            <Input
              id="word"
              aria-describedby="word"
              value={this.state.layer}
              onChange={(e) => this.handleChangeText("layer", e)}
              error={this.handleError(this.state.layer)}
            />
            {this.handleError(this.state.layer) ? (
              <FormHelperText>This field is required</FormHelperText>
            ) : null}
          </FormControl>{" "}
          <FormControl fullWidth>
            <InputLabel htmlFor="wordTarget">Sublayer</InputLabel>
            <Input
              id="wordTarget"
              aria-describedby="wordTarget"
              fullWidth={true}
              value={this.state.sublayer}
              onChange={(e) => this.handleChangeText("sublayer", e)}
              error={this.handleError(this.state.sublayer)}
            />
            {this.handleError(this.state.sublayer) ? (
              <FormHelperText>This field is required</FormHelperText>
            ) : null}
          </FormControl>{" "}
          <FormControl fullWidth>
            <InputLabel htmlFor="wordTarget">Kategori</InputLabel>
            <Input
              id="wordTarget"
              aria-describedby="wordTarget"
              fullWidth={true}
              value={this.state.kategori}
              onChange={(e) => this.handleChangeText("kategori", e)}
              error={this.handleError(this.state.kategori)}
            />
            {this.handleError(this.state.kategori) ? (
              <FormHelperText>This field is required</FormHelperText>
            ) : null}
          </FormControl>{" "}
        </Grid>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <br />
          <Button variant="contained" color="primary" onClick={this.submitForm}>
            Save
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default EditCms;
